export default function validateInput(
  inputString: string,
  type: string,
): boolean {
  let result = false;
  if (type === 'eng') {
    const regex = /^$|^[0-9a-zA-Z　 !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]+$/;
    result = regex.test(inputString);
  } else if (type === 'alphabet') {
    const regex = /^$|^[a-zA-Z]*$/;
    result = regex.test(inputString);
  } else if (type === 'jp') {
    const regex =
      /^$|^[\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf\u2E80-\u2FD5\uFF5F-\uFF9F\u3000-\u303F\u31F0-\u31FF\u3220-\u3243\u3280-\u337F!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~　 ]+$/;
    result = regex.test(inputString);
  } else if (type === 'jp-katakana') {
    const regex =
      /^$|^[0-9\u30A0-\u30FF\uFF5F-\uFF9F　 !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]+$/;
    result = regex.test(inputString);
  } else if (type === 'number') {
    const regex = /^$|^[0-9]*$/;
    result = regex.test(inputString);
  } else {
    result = true;
  }
  return result;
}
